import React, { Component } from 'react';
import { connect } from 'react-redux';
import AlertContainer from 'react-alert';
import { isMobileOnly } from 'react-device-detect';
import FontAwesome from 'react-fontawesome';
import logo from './assets/logo.svg';

// import { loadReCaptcha } from 'react-recaptcha-v3';

// import { GOOGLE_RECPATCHA_KEY } from './constants';

import 'bootstrap/dist/css/bootstrap.css';
import './main.css';

// import actions from './redux/actions';

class App extends Component {
  alertOptions = {
    offset: 14,
    position: 'bottom right',
    theme: 'dark',
    time: 5000,
    transition: 'scale',
  };

  constructor(...args) {
    super(...args);
    this.state = {};
  }

  componentDidMount() {
    // loadReCaptcha(GOOGLE_RECPATCHA_KEY);
    // Check if the protocol is HTTP and redirect to HTTPS
    if (window.location.protocol === 'http:' && window.location.hostname !== 'localhost') {
      window.location.href = 'https://' + window.location.host + window.location.pathname;
    }
  }

  componentWillReceiveProps(nextProps) {
    const { alertId, alertType, alertMsg } = nextProps;

    if (alertId !== this.props.alertId && alertMsg) {
      let delayTime =
        alertType === 'success' || alertType === 'info' ? 5000 : 30000;

      if (alertType === 'success') {
        this.alert.success(alertMsg, {
          time: delayTime,
          icon: <FontAwesome name="check-circle" />,
        });
      } else if (alertType === 'error') {
        this.alert.error(alertMsg, {
          time: delayTime,
          icon: <FontAwesome name="exclamation-circle" />,
        });
      } else if (alertType === 'info') {
        this.alert.error(alertMsg, {
          time: delayTime,
          icon: <FontAwesome name="info-circle" />,
        });
      }
    } else {
      this.alert.removeAll();
    }
  }

  render() {
    if (isMobileOnly) {
      return (
        <div className="app-container">
          <div className="device-notification">
            <div className="site-logo">
              <a href="https://cosynd.com">
                <img src={logo} alt="logo" width="80px" />
              </a>
            </div>
            <div>
              <strong>Thanks for using Cosynd!</strong>
            </div>
            <div>
              We strongly recommend that you use Cosynd from a laptop or desktop
              for the best experience. Otherwise, you might run into a few
              issues.
            </div>
            <div>We'll let you know when our mobile version is ready!</div>
          </div>
        </div>
      );
    }

    return (
      <div className="app-container">
        {this.props.children}
        <div className={`alert-container ${this.props.alertType}`}>
          <AlertContainer
            ref={(a) => (this.alert = a)}
            {...this.alertOptions}
          />
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  alertType: state.alert.type,
  alertMsg: state.alert.msg,
  alertId: state.alert.id,
});

const mapDispatchToProps = (dispatch) => ({});

export default connect(mapStateToProps, mapDispatchToProps)(App);



// WEBPACK FOOTER //
// src/App.js